/* global Blockly */
import React from 'react';
import util from "../../../../../../utils/es5Utils";

function defineBlock(context) {
    let plusImage = "data:image/svg+xml;base64,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";
    let minusImage = "data:image/svg+xml;base64,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";
    let expandImage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS4yMzMiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDExLjIzMyA2Ij4NCiAgPHBhdGggZmlsbD0icmdiKDI1NSwyNTUsMjU1KSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMCAwbDUuMzcyNDYzNzcgNiA1Ljg2MDg2OTU2LTZIMHoiLz4NCjwvc3ZnPg0K";
    let collapseImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAAAXNSR0IArs4c6QAAAHJJREFUKFN9ziEOwmAQROE3N0P1ECQVSGQVR8DVNEGiQHKCmp4BxRVQHOGRJm3Tkj+snP12M6Ew6gPokgzrdX6tegf2wBvYJXnNZoPVK3BYPXhOB58xW7B6AY6FVn2SasFqCzSl/lN2S1JHPQOnP3BetV+1mR+Q68NL8gAAAABJRU5ErkJggg==";
    return {
        conditionsNumber: 0,
        expandableAfterNumber: 1,
        isExpanded: false,
        compareOperators: [['=', 'EQUAL'], ['>', 'LARGER'], ['>=', 'LARGEREQUAL'], ['<', 'LESS'], ['<=', 'LESSEQUAL'], ['!=', 'NOTEQUAL'], ['contains', 'CONTAIN']],
        logicalOperators: [['AND', 'AND'], ['OR', 'OR']],
        columnNames: [['column name', 'ColName']],

        init: function () {
            let selectTableDropdown = new Blockly.FieldWidgetsDropdown(context, 'tableview', undefined, '- select -', this.updateWidget_.bind(this));

            this.appendDummyInput("SHOWHIDE")
                .appendField(new Blockly.FieldDropdown([['show', 'show'], ['hide', 'hide']]), "ACTION");

            this.appendDummyInput('WIDGET')
                .appendField("row from")
                .appendField(selectTableDropdown, "ID")
                .appendField("where");

            this.appendDummyInput("TOGGLE_BTN")
                .appendField(new Blockly.FieldImage(expandImage, 20, 20, "expand", function () { this.toggleConditionsVisibility_(); }.bind(this)), "expand")
                .appendField(new Blockly.FieldImage(collapseImage, 20, 20, "collapse", function () { this.toggleConditionsVisibility_(); }.bind(this)), "collapse");

            this.appendDummyInput('PLUS_MINUS')
                .appendField(" ")
                .appendField(new Blockly.FieldImage(minusImage, 24, 24, "*", this.removeCondition_.bind(this)), "MINUS")
                .appendField(new Blockly.FieldImage(plusImage, 24, 24, "*", this.addCondition_.bind(this)), "PLUS");

            this.addCondition_();

            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Show/hide a row(s) in a TableView widget.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#Table`);
            this.hideExpandCollapseButtons_();
            this.getField('MINUS').setVisible(false);
        },

        onLoad: function() {
            for (let i = 1; i <= this.conditionsNumber; i++) {
                this.getField(`COLUMN_NAME_${i}`).validate();
            }
        },

        /**
          * Create XML to represent list inputs.
          * @return {!Element} XML storage element.
          * @this {Blockly.Block}
          */
        mutationToDom: function () {
            let container = Blockly.utils.xml.createElement('mutation');
            container.setAttribute('conditionsNumber', this.conditionsNumber);
            container.setAttribute('ID', this.getFieldValue('ID'));
            return container;
        },

        /**
         * Parse XML to restore the list inputs.
         * @param {!Element} xmlElement XML storage element.
         * @this {Blockly.Block}
         */
        domToMutation: function (xml) {
            let conditionsNumber = parseInt(xml.getAttribute("conditionsNumber"));
            let ID = xml.getAttribute("ID");

            this.getTableColumns_(ID);

            let conditionsNum = conditionsNumber;
            while (this.conditionsNumber > 0) {
                this.removeCondition_();
            }
            
            for (let i = 0; i < conditionsNum; i++) {
                this.addCondition_();
            }
        },

        updateWidget_: function (selectedTableId) {
            if (selectedTableId === '- select -') return;
            
            this.getTableColumns_(selectedTableId);

            let conditionsNum = this.conditionsNumber;
            while (this.conditionsNumber > 0) {
                this.removeCondition_();
            }

            for (let i = 1; i <= conditionsNum; i++) {
                this.addCondition_();
            }
        },

        getTableColumns_: function (tableId) {
            context.pages.forEach(page => {
                let table = page.widgets.find(widget => widget.id == tableId);

                if (table) {
                    this.columnNames = table.columns.some(column => column) ? table.columns.map(column => [column.name, column.id]) : [['column name', 'ColName']];
                    return;
                }
            });
        },

        hideExpandCollapseButtons_: function () {
            this.getField('expand').setVisible(false);
            this.getField('collapse').setVisible(false);
        },

        toggleExpandCollapseButtonsVisibility_: function () {
            this.getField('expand').setVisible(!this.isExpanded);
            this.getField('collapse').setVisible(this.isExpanded);
        },

        toggleConditionsVisibility_: function () {
            this.isExpanded = !this.isExpanded;

            let toggleButtonIndex = this.inputList.findIndex(input => input.name == 'TOGGLE_BTN');
            this.inputList.slice(toggleButtonIndex + 1).forEach(function (input) {
                input.setVisible(this.isExpanded);
                if (input.connection && input.connection.targetBlock()) {
                    input.connection.targetBlock().initSvg();
                    input.connection.targetBlock().render();
                }
            }.bind(this));

            this.toggleExpandCollapseButtonsVisibility_();
            this.render();
        },

        addCondition_: function () {
            this.conditionsNumber++;

            let condition = this.appendValueInput(`CONDITION_${this.conditionsNumber}`)
                .appendField(" ")
                .appendField(new Blockly.FieldDropdown(this.columnNames), `COLUMN_NAME_${this.conditionsNumber}`, '- select -')
                .appendField(new Blockly.FieldDropdown(this.compareOperators), `COMPARE_OPERATOR_${this.conditionsNumber}`)
                .setOnNewRow(this.conditionsNumber > this.expandableAfterNumber);

            this.moveInputBefore(condition.name, "PLUS_MINUS");

            if (this.conditionsNumber > 1) {
                this.appendDummyInput(`CONDITION_LOGICAL_OPERATOR_${this.conditionsNumber}`)
                    .appendField(" ")
                    .appendField(new Blockly.FieldDropdown(this.logicalOperators), `LOGICAL_OPERATOR_${this.conditionsNumber}`);
                this.moveInputBefore(`CONDITION_LOGICAL_OPERATOR_${this.conditionsNumber}`, condition.name);
            }

            if (this.conditionsNumber == 2) {
                this.getField('MINUS').setVisible(true);
            }

            if (this.conditionsNumber == this.expandableAfterNumber + 1) {
                this.isExpanded = true;
                this.toggleExpandCollapseButtonsVisibility_();

                for (let i = this.expandableAfterNumber; i >= 1; i--) {
                    this.getInput(`CONDITION_${i}`).setOnNewRow(true);
                }
            }

            let inputBlock = this.workspace.newBlock("fixed_width_text");
            inputBlock.setDisplayWidth(9);
            inputBlock.setShadow(true);
            inputBlock.setMovable(false);

            condition.connection.connect(inputBlock.outputConnection);

            if (this.rendered) {
                inputBlock.initSvg();
                inputBlock.render();
                this.initSvg();
                this.render();
            }
        },

        removeCondition_: function () {
            this.removeInput(`CONDITION_${this.conditionsNumber}`);

            if (this.conditionsNumber > 1) {
                this.removeInput(`CONDITION_LOGICAL_OPERATOR_${this.conditionsNumber}`);
            }

            if (this.conditionsNumber == 2) {
                this.getField('MINUS').setVisible(false);
            }

            if (this.conditionsNumber == this.expandableAfterNumber + 1) {
                this.hideExpandCollapseButtons_();

                for (let i = 1; i < this.expandableAfterNumber; i++) {
                    this.getInput(`CONDITION_${i}`).setOnNewRow(false);
                    this.moveInputBefore(`CONDITION_${i}`, `CONDITION_${i + 1}`);

                    this.getInput(`CONDITION_LOGICAL_OPERATOR_${i + 1}`).setOnNewRow(false);;
                    this.moveInputBefore(`CONDITION_LOGICAL_OPERATOR_${i + 1}`, `CONDITION_${i + 1}`);
                }

                this.getInput(`CONDITION_${this.expandableAfterNumber}`).setOnNewRow(false);;
                this.moveInputBefore(`CONDITION_${this.expandableAfterNumber}`, `PLUS_MINUS`);
            }

            if (this.rendered) {
                this.render();
            }

            this.conditionsNumber--;
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let columns = [];
            let compares = [];
            let inputs = [];
            let conditions = [];
            let id = block.getFieldValue('ID');
            let isHide = block.getFieldValue("ACTION") === "hide";

            for (let i = 1; i <= this.conditionsNumber; i++) {
                columns.push(`"${block.getFieldValue(`COLUMN_NAME_${i}`)}"`);
                compares.push(`"${block.getFieldValue(`COMPARE_OPERATOR_${i}`)}"`);
                inputs.push(Blockly.JavaScript.valueToCode(block, `CONDITION_${i}`, Blockly.JavaScript.ORDER_NONE));
            }

            for (let i = 2; i <= this.conditionsNumber; i++) {
                conditions.push(`"${block.getFieldValue(`LOGICAL_OPERATOR_${i}`)}"`);
            }

            let columnsList = `[${columns.join(', ')}]`;
            let comparesList = `[${compares.join(', ')}]`;
            let inputsList = `[${inputs.join(', ')}]`;
            let conditionsList = `[${conditions.join(', ')}]`;
            let code = `Snap.widgets.tableview.hideRecords("${id}",${columnsList},${comparesList},${inputsList},${conditionsList},${isHide});\n`;

            return code;
        }
    }
}


const ShowHideRow = function (props) {
    const name = 'snap_showhide_row';
    ShowHideRow.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    let widgets = util.widgetsOfType(props.context, "tableview");

    if (widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {
                props.widget && (props.widget.id !== undefined)
                    ? <field name="ID">{props.widget.id}</field>
                    : null
            }
        </block>
    );
}

export default ShowHideRow;
